import { useUpdateButterflyConnection } from '@/api/property-keyless/butterfly/update-butterfly-connection'

import { ButterflyConnectionFormValues } from './butterfly.schema'

export const useButterflySubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateButterflyConnection()

  const submit = (values: ButterflyConnectionFormValues) =>
    mutateAsync({
      authorizationCode: values.authorizationCode,
      buildingId,
      config: {
        shouldAutoAssignApartmentDoorVisitor: values.shouldAutoAssignApartmentDoorVisitor,
        visitorPermissionDoors: values.visitorPermissionDoors,
      },
    })

  return { isPending, submit }
}
